/* eslint-disable menti-react/forbidden-filename */
const layoutWith3Rows = {
  row1: 2 / 16,
  row2: 7 / 16,
  row3: 12 / 16,
};

// Describes center positions of each data buckets, grouped by number of buckets
export const BUCKET_LAYOUTS = {
  1: [{ x: 1 / 2, y: 5 / 8 }],
  2: [
    { x: 2 / 6, y: 5 / 8 },
    { x: 4 / 6, y: 5 / 8 },
  ],
  3: [
    { x: 1 / 6, y: 5 / 8 },
    { x: 3 / 6, y: 5 / 8 },
    { x: 5 / 6, y: 5 / 8 },
  ],
  4: [
    { x: 2 / 6, y: 1 / 4 },
    { x: 4 / 6, y: 1 / 4 },

    { x: 2 / 6, y: 3 / 4 },
    { x: 4 / 6, y: 3 / 4 },
  ],
  5: [
    { x: 1 / 6, y: 1 / 4 },
    { x: 3 / 6, y: 1 / 4 },
    { x: 5 / 6, y: 1 / 4 },

    { x: 2 / 6, y: 3 / 4 },
    { x: 4 / 6, y: 3 / 4 },
  ],
  6: [
    { x: 1 / 6, y: 1 / 4 },
    { x: 3 / 6, y: 1 / 4 },
    { x: 5 / 6, y: 1 / 4 },

    { x: 1 / 6, y: 3 / 4 },
    { x: 3 / 6, y: 3 / 4 },
    { x: 5 / 6, y: 3 / 4 },
  ],
  7: [
    { x: 2 / 16, y: 1 / 4 },
    { x: 6 / 16, y: 1 / 4 },
    { x: 10 / 16, y: 1 / 4 },
    { x: 14 / 16, y: 1 / 4 },

    { x: 2 / 8, y: 3 / 4 },
    { x: 4 / 8, y: 3 / 4 },
    { x: 6 / 8, y: 3 / 4 },
  ],
  8: [
    { x: 2 / 16, y: 1 / 4 },
    { x: 6 / 16, y: 1 / 4 },
    { x: 10 / 16, y: 1 / 4 },
    { x: 14 / 16, y: 1 / 4 },

    { x: 2 / 16, y: 3 / 4 },
    { x: 6 / 16, y: 3 / 4 },
    { x: 10 / 16, y: 3 / 4 },
    { x: 14 / 16, y: 3 / 4 },
  ],
  9: [
    { x: 1 / 6, y: layoutWith3Rows.row1 },
    { x: 3 / 6, y: layoutWith3Rows.row1 },
    { x: 5 / 6, y: layoutWith3Rows.row1 },
    { x: 1 / 6, y: layoutWith3Rows.row2 },
    { x: 3 / 6, y: layoutWith3Rows.row2 },
    { x: 5 / 6, y: layoutWith3Rows.row2 },
    { x: 1 / 6, y: layoutWith3Rows.row3 },
    { x: 3 / 6, y: layoutWith3Rows.row3 },
    { x: 5 / 6, y: layoutWith3Rows.row3 },
  ],
  10: [
    { x: 2 / 8, y: layoutWith3Rows.row1 },
    { x: 4 / 8, y: layoutWith3Rows.row1 },
    { x: 6 / 8, y: layoutWith3Rows.row1 },
    { x: 2 / 16, y: layoutWith3Rows.row2 },
    { x: 6 / 16, y: layoutWith3Rows.row2 },
    { x: 10 / 16, y: layoutWith3Rows.row2 },
    { x: 14 / 16, y: layoutWith3Rows.row2 },
    { x: 2 / 8, y: layoutWith3Rows.row3 },
    { x: 4 / 8, y: layoutWith3Rows.row3 },
    { x: 6 / 8, y: layoutWith3Rows.row3 },
  ],
  11: [
    { x: 2 / 16, y: layoutWith3Rows.row1 },
    { x: 6 / 16, y: layoutWith3Rows.row1 },
    { x: 10 / 16, y: layoutWith3Rows.row1 },
    { x: 14 / 16, y: layoutWith3Rows.row1 },
    { x: 2 / 8, y: layoutWith3Rows.row2 },
    { x: 4 / 8, y: layoutWith3Rows.row2 },
    { x: 6 / 8, y: layoutWith3Rows.row2 },
    { x: 2 / 16, y: layoutWith3Rows.row3 },
    { x: 6 / 16, y: layoutWith3Rows.row3 },
    { x: 10 / 16, y: layoutWith3Rows.row3 },
    { x: 14 / 16, y: layoutWith3Rows.row3 },
  ],
  12: [
    { x: 2 / 16, y: layoutWith3Rows.row1 },
    { x: 6 / 16, y: layoutWith3Rows.row1 },
    { x: 10 / 16, y: layoutWith3Rows.row1 },
    { x: 14 / 16, y: layoutWith3Rows.row1 },
    { x: 2 / 16, y: layoutWith3Rows.row2 },
    { x: 6 / 16, y: layoutWith3Rows.row2 },
    { x: 10 / 16, y: layoutWith3Rows.row2 },
    { x: 14 / 16, y: layoutWith3Rows.row2 },
    { x: 2 / 16, y: layoutWith3Rows.row3 },
    { x: 6 / 16, y: layoutWith3Rows.row3 },
    { x: 10 / 16, y: layoutWith3Rows.row3 },
    { x: 14 / 16, y: layoutWith3Rows.row3 },
  ],
};

export const SEGMENTED_BUCKET_LAYOUTS = {
  1: [{ x: 6 / 18, y: 5 / 8 }],
  2: [
    { x: 2 / 9, y: 5 / 8 },
    { x: 4 / 9, y: 5 / 8 },
  ],
  3: [
    { x: 1 / 9, y: 5 / 8 },
    { x: 3 / 9, y: 5 / 8 },
    { x: 5 / 9, y: 5 / 8 },
  ],
  4: [
    { x: 2 / 9, y: 1 / 4 },
    { x: 4 / 9, y: 1 / 4 },

    { x: 2 / 9, y: 3 / 4 },
    { x: 4 / 9, y: 3 / 4 },
  ],
  5: [
    { x: 1 / 9, y: 1 / 4 },
    { x: 3 / 9, y: 1 / 4 },
    { x: 5 / 9, y: 1 / 4 },

    { x: 2 / 9, y: 3 / 4 },
    { x: 4 / 9, y: 3 / 4 },
  ],
  6: [
    { x: 1 / 9, y: 1 / 4 },
    { x: 3 / 9, y: 1 / 4 },
    { x: 5 / 9, y: 1 / 4 },

    { x: 1 / 9, y: 3 / 4 },
    { x: 3 / 9, y: 3 / 4 },
    { x: 5 / 9, y: 3 / 4 },
  ],
  7: [
    { x: 3 / 32, y: 1 / 4 },
    { x: 9 / 32, y: 1 / 4 },
    { x: 15 / 32, y: 1 / 4 },
    { x: 21 / 32, y: 1 / 4 },

    { x: 6 / 32, y: 3 / 4 },
    { x: 12 / 32, y: 3 / 4 },
    { x: 18 / 32, y: 3 / 4 },
  ],
  8: [
    { x: 3 / 32, y: 1 / 4 },
    { x: 9 / 32, y: 1 / 4 },
    { x: 15 / 32, y: 1 / 4 },
    { x: 21 / 32, y: 1 / 4 },

    { x: 3 / 32, y: 3 / 4 },
    { x: 9 / 32, y: 3 / 4 },
    { x: 15 / 32, y: 3 / 4 },
    { x: 21 / 32, y: 3 / 4 },
  ],
  9: [
    { x: 1 / 9, y: layoutWith3Rows.row1 },
    { x: 3 / 9, y: layoutWith3Rows.row1 },
    { x: 5 / 9, y: layoutWith3Rows.row1 },

    { x: 1 / 9, y: layoutWith3Rows.row2 },
    { x: 3 / 9, y: layoutWith3Rows.row2 },
    { x: 5 / 9, y: layoutWith3Rows.row2 },

    { x: 1 / 9, y: layoutWith3Rows.row3 },
    { x: 3 / 9, y: layoutWith3Rows.row3 },
    { x: 5 / 9, y: layoutWith3Rows.row3 },
  ],
  10: [
    { x: 6 / 32, y: layoutWith3Rows.row1 },
    { x: 12 / 32, y: layoutWith3Rows.row1 },
    { x: 18 / 32, y: layoutWith3Rows.row1 },

    { x: 3 / 32, y: layoutWith3Rows.row2 },
    { x: 9 / 32, y: layoutWith3Rows.row2 },
    { x: 15 / 32, y: layoutWith3Rows.row2 },
    { x: 21 / 32, y: layoutWith3Rows.row2 },

    { x: 6 / 32, y: layoutWith3Rows.row3 },
    { x: 12 / 32, y: layoutWith3Rows.row3 },
    { x: 18 / 32, y: layoutWith3Rows.row3 },
  ],
  11: [
    { x: 3 / 32, y: layoutWith3Rows.row1 },
    { x: 9 / 32, y: layoutWith3Rows.row1 },
    { x: 15 / 32, y: layoutWith3Rows.row1 },
    { x: 21 / 32, y: layoutWith3Rows.row1 },

    { x: 6 / 32, y: layoutWith3Rows.row2 },
    { x: 12 / 32, y: layoutWith3Rows.row2 },
    { x: 18 / 32, y: layoutWith3Rows.row2 },

    { x: 3 / 32, y: layoutWith3Rows.row3 },
    { x: 9 / 32, y: layoutWith3Rows.row3 },
    { x: 15 / 32, y: layoutWith3Rows.row3 },
    { x: 21 / 32, y: layoutWith3Rows.row3 },
  ],
  12: [
    { x: 3 / 32, y: layoutWith3Rows.row1 },
    { x: 9 / 32, y: layoutWith3Rows.row1 },
    { x: 15 / 32, y: layoutWith3Rows.row1 },
    { x: 21 / 32, y: layoutWith3Rows.row1 },

    { x: 3 / 32, y: layoutWith3Rows.row2 },
    { x: 9 / 32, y: layoutWith3Rows.row2 },
    { x: 15 / 32, y: layoutWith3Rows.row2 },
    { x: 21 / 32, y: layoutWith3Rows.row2 },

    { x: 3 / 32, y: layoutWith3Rows.row3 },
    { x: 9 / 32, y: layoutWith3Rows.row3 },
    { x: 15 / 32, y: layoutWith3Rows.row3 },
    { x: 21 / 32, y: layoutWith3Rows.row3 },
  ],
};

export const SEGMENTED_LEGEND_LAYOUTS = [
  // 1
  { x: 10 / 18 },
  // 2
  { x: 5 / 9 },
  // 3
  { x: 6 / 9 },
  // 4
  { x: 5 / 9 },
  // 5
  { x: 6 / 9 },
  // 6
  { x: 6 / 9 },
  // 7
  { x: 24 / 32 },
  // 8
  { x: 24 / 32 },
  // 9
  { x: 6 / 9 },
  // 10
  { x: 24 / 32 },
  // 11
  { x: 24 / 32 },
  // 12
  { x: 24 / 32 },
];
